module.exports = __webpack_public_path__ + "img/ReshapetheFuture.46a2e3b9.png";